import React, { useEffect, useCallback, useRef } from 'react';
import styled from 'styled-components';
import { getNeutralColors } from '../theme';

const StyledList = styled.ul`
  list-style: none;
  min-width: 135px;
  max-height: 380px;
  overflow-y: scroll;
  border: ${props => `1px solid ${getNeutralColors('grisMedioOscuro')(props)}`};
  border-radius: 8px;
  background: ${getNeutralColors('white')};
  margin: ${props => (props.margin ? props.margin : '9px 0 0 0')};
  padding: ${props => (props.padding ? props.padding : '0')};
`;

const DropdownList = ({
  children,
  onArrowUp = () => {},
  onArrowDown = () => {},
  onEscape = () => {},
  onEnter = () => {},
  margin,
  padding
}) => {
  const listRef = useRef();

  const handleKeyDown = useCallback(
    e => {
      e.preventDefault();

      if (e.key === 'ArrowUp') {
        onArrowUp(e, listRef.current);
      }

      if (e.key === 'ArrowDown') {
        onArrowDown(e, listRef.current);
      }

      if (e.key === 'Enter') {
        onEnter(e);
      }

      if (e.key === 'Escape') {
        onEscape(e);
      }
    },
    [onArrowDown, onArrowUp, onEscape, onEnter]
  );

  const childrens = React.Children.map(children, child => {
    if (!React.isValidElement(child)) {
      return child;
    }

    return React.cloneElement(child, {
      ...child.props
    });
  });

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return (
    <StyledList ref={listRef} margin={margin} padding={padding}>
      {childrens}
    </StyledList>
  );
};

export default DropdownList;
